/**
 * Who may see online-staff presence (sidebar stack + online-users widget + /dashboard/online-users).
 * Matches backend role_required(["admin", "Manager"]).
 */
export function canViewOnlineStaffPresence(roleLike) {
  const r = String(roleLike ?? "")
    .trim()
    .toLowerCase();
  return r === "admin" || r === "manager";
}
